import { FC, PropsWithChildren, createContext, useContext } from 'react'
import { useLocalStorage } from 'react-use'
import invariant from 'tiny-invariant'

interface FFValue {
  uiEnabled: boolean
  flags: Record<string, boolean>
}

interface FFContextValue {
  ff: FFValue
  setFF(ff: FFValue): void
}

const LocalStorageFFContext = createContext<FFContextValue>(
  {} as FFContextValue
)

export const FF_DEFAULT_VALUE: FFValue = {
  uiEnabled: false,
  flags: {}
}

export const useLocalStorageFF = () => {
  const context = useContext(LocalStorageFFContext)

  invariant(
    context,
    'useLocalStorageFF must be used within a LocalStorageFFProvider'
  )

  return context
}

export const LocalStorageFFProvider: FC<PropsWithChildren> = ({ children }) => {
  const [ff, setFF] = useLocalStorage('ff', FF_DEFAULT_VALUE)

  return (
    <LocalStorageFFContext.Provider value={{ ff, setFF } as FFContextValue}>
      {children}
    </LocalStorageFFContext.Provider>
  )
}
